import { BASIC_INITIAL_STATE } from '../../../common/utils/HttpHelper';
import getPersonAcknowledgements from './GetPersonAcknowledgements';
import postPersonAcknowledgements from './PostPersonAcknowledgements';

const INITIAL_STATE = { ...BASIC_INITIAL_STATE };

const PersonAcknowledgementData = { INITIAL_STATE, getPersonAcknowledgements, postPersonAcknowledgements };
export default PersonAcknowledgementData;
